<template>
  <div class="wrapper-order wh100p">
    <section class="section-navs df">
      <div
        v-for="(x,i) in navs" :key="i"
        class="nav f-m" :class="{'_themecolor active':navIndex===i}"
        @click="selectNav(x,i)">
        <el-badge :value="i===1&&expiredNoReturnCashOrderNum>0?expiredNoReturnCashOrderNum:''" class="dot">
          <div>{{$t('order.'+x.name)}}</div>
        </el-badge>
      </div>
    </section>

    <section class="section-search _bordertop df-c-sb">
      <div class="df-c-fs box">
        <input
          type="number" class="input" :placeholder="$t('order.searchContent')" v-model.number="searchKey"
          @input="searchClick" @focus="onFocus_forScan" @blur="onBlur_forScan" >
        <img src="@/assets/icons/magnifier.png" class="icon" @click="isDrawerAc=!isDrawerAc">
        <div class="text f-xs" @click="searchClearClick">{{$t('common.clear')}}</div>
      </div>
      <div class="df-w-c-fs box3 f1 _borderleft">
        <div class="btn" :class="x.id===quickFilterBtnSelected?'themebtn-xs':'whitebtn-xs'" v-for="(x,i) in quickFilterBtns" :key="i" @click="quickFilterClick(x)">{{x['name'+_lang]}}</div>
      </div>
      <div class="df-c-fs box box2">
        <img
          class="transition" :class="isDrawerAc?'rotate90':'rotate-90'" style="width:24px;height:24px;"
          :src="iconArrowLeft" @click="isDrawerAc=!isDrawerAc">
      </div>
    </section>

    <section class="section-drawer w100p">
      <section class="drawer df-l-fs" :class="{'_bordertop active':isDrawerAc}">
        <div class="items df-sb">
          <div class="item" v-for="(x,i) in filters" :key="i">
            <div class="item-label df">
              <div class="f-xs" style="margin-right:22px;color: #1890FF;">{{$t(x.label)}}</div>
            </div>
            <div class="item-options df-w-c-fs">
              <div class="option df-c-fs" @click="selectAll(x)">
                <img :src="x.select?iconCheckok:iconChecknull" style="width:16px;height:16px;margin-right:4px;">
                <span class="value f-xxs">{{$t('order.selectAll')}}</span>
              </div>
            </div>
            <div class="item-options df-w-c-fs">
              <div class="option df-c-fs" :class="{'option-l':x2.long}" v-for="(x2,i2) in x.child" :key="i2" @click="selectItem(x2,x)">
                <img :src="x2.select?iconCheckok:iconChecknull" style="width:16px;height:16px;margin-right:4px;">
                <span class="value f-xxs">{{x2['name'+_lang]}}</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>

    <section class="section-table">
      <div class="table-box" ref="tablebox">
        <el-table
          ref="multipleTable"
          :data="tableDatas"
          :max-height="tableMaxHeight"
          :row-class-name="tableRowClassName"
          @selection-change="rowSelectedHandler"
          @row-click="rowClickedHandler">
          <!-- stripe border highlight-current-row -->
          <el-table-column type="selection" width="42" align="center"></el-table-column>
          <el-table-column :label="$t('order.orderNo')" min-width="80" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.orderNo|tothousands}}</span>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip v-for="(x,i) in tableOptions" :key="i"
            :prop="x.key" :label="$t('order.'+x.key)" :min-width="x.width||'80'" :align="x.align||'center'"></el-table-column>
          <el-table-column :label="$t('order.orderTypeText')" min-width="80" align="center">
            <template slot-scope="scope">
              <span>{{$t('order.orderType'+scope.row.orderType)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('order.userCost')" prop="userCost" min-width="60" align="center">
            <template slot-scope="scope">
              <span v-if="sysEnv_x==='hk'">{{scope.row.userCost|toprice(2)}}</span>
              <span v-else-if="sysEnv_x==='us'">{{scope.row.costOrigin|toprice(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.tip')" prop="tipsFee" min-width="50" align="center" v-if="sysEnv_x==='us'">
            <template slot-scope="scope">
              <div class="w100p df-c-ct">
                <div
                  :class="{'edit-btn df-c-ct f-white _themebackground':scope.row.stripeTerminal}"
                  @click.stop.prevent="tipClickHandler(scope.row)">
                  {{(scope.row.tipsFee+scope.row.serviceFee)|toprice(2)}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('order.payway')" min-width="100" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <template v-if="scope.row.combineOrder">
                <span style="color:#ddd;">{{$t('order.payStatus01')}}</span>
              </template>
              <template v-else-if="scope.row.returnCash">
                <span style="color:orange;">{{$t('order.payStatus0')}}</span>
              </template>
              <template v-else-if="scope.row.payTypeNameList.length">
                <span :style="[8,9,10].includes(scope.row.status)?'color:#EB5050;':''" v-for="(x,i) in scope.row.payTypeNameList" :key="i">
                  <span>{{x['name'+_lang]}}</span>
                  <span v-if="i<scope.row.payTypeNameList.length-1">,</span>
                </span>
              </template>
              <template v-else-if="scope.row.payTypeList.length">
                <span :style="[8,9,10].includes(scope.row.status)?'color:#EB5050;':''" v-for="(x,i) in scope.row.payTypeList" :key="i">
                  <span>{{$t('order.payWay'+x)}}</span>
                  <span v-if="i<scope.row.payTypeList.length-1">,</span>
                </span>
              </template>
              <template v-else-if="scope.row.payType">
                <span :style="[8,9,10].includes(scope.row.status)?'color:#EB5050;':''">{{$t('order.payWay'+scope.row.payType)}}</span>
              </template>
              <template v-else>
                <span style="color:#EB5050;">{{$t('order.payStatus1')}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.action')" width="140" align="center">
            <template slot-scope="scope">
              <div class="df-c-sa">
                <template v-if="navIndex===0">
                  <div class="edit-btn df-c-ct f-white _themebackground" @click.stop.prevent="editOrderClick(scope.row)">{{$t('common.edit')}}</div>
                  <div class="delete-btn df-c-ct" @click.stop.prevent="cancelOrderClick(scope.row)" :class="{'delete-btn-disable':scope.row.status>7}">
                    <img src="@/assets/icons/trash.png" style="width:14px;height:17px;">
                  </div>
                </template>
                <template v-else-if="!scope.row.returnCash">
                  <div class="edit-btn df-c-ct f-white _redbackground" @click.stop.prevent="refundOrderClick(scope.row)" >{{$t('common.refund')}}</div>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagenation :pageData="pageData" @pageChange="pageChange" />
      <div class="section-btns df-c-fe" v-if="navIndex===0">
        <div class="whitebtn btn" @click="printOrderClick">{{$t('common.print')}}</div>
        <div class="themebtn btn" @click="calcClick">{{$t('common.pay')}}</div>
      </div>
    </section>

    <Dialog
      ref="Dialog_print"
      :dialogTitle="$t('common.print')"
      contentWidth="520">
      <!-- :closeable="false" -->

      <div class="mydialog-merge df-l-c-ct" slot="content">
        <div class="text f-xl f-dark">{{$t('print.selectYourPrintWay')}}</div>
        <div class="text f-xl f-dark"></div>
      </div>
      <template slot="footer">
        <div class="whitebtn" @click="batchPrint()">{{$t('print.batchPrint')}}</div>
        <div class="themebtn" @click="mergePrint()">{{$t('print.mergePrint')}}</div>
      </template>
    </Dialog>

    <Dialog
      ref="Dialog_merge"
      :dialogTitle="$t('common.warning2')"
      contentWidth="520">
      <!-- :closeable="false" -->

      <div class="mydialog-merge df-l-c-ct" slot="content">
        <div class="text f-xl f-dark">{{$t('print.mergeWarningMessage1')}}</div>
        <div class="text f-xl f-dark">{{$t('print.mergeWarningMessage2')}}</div>
      </div>
      <template slot="footer">
        <div class="whitebtn" @click="closeDialogMerge">{{$t('common.cancel')}}</div>
        <div class="themebtn" @click="continueMerge()">{{$t('common.comfirm')}}</div>
      </template>
    </Dialog>

    <DialogKey ref="DialogKey" />

    <DialogError ref="DialogError" :messages="stockErrorFoods" />

    <DialogTip ref="DialogTip" @submitDialog="search" />

  </div>
</template>

<script>
import mixin_table_simple from '@/mixins/mixin_table_simple'
import mixin_print from '@/mixins/mixin_print'
export default {
  name: 'order',
  mixins: [mixin_table_simple, mixin_print],
  data() {
    return {
      navs: [
        {name:'orderManage'},
        {name:'orderManage2'},
      ],
      navIndex: 0,

      searchKey: '',
      orderIdKey: '',
      isDrawerAc: false,
      filters: [
        {label:'order.payWay',select:false,child:[
          // {select:false,name_zh:'現金',name_en:'Cash',value:5},
          // {select:false,name_zh:'微信',name_en:'WeChat Pay',value:1},
          // {select:false,name_zh:'支付寶',name_en:'Alipay',value:2},
          // {select:false,name_zh:'八達通',name_en:'Octopus',value:8},
          // {select:false,name_zh:'銀聯',name_en:'UnionPay',value:9},
          // {select:false,name_zh:'Visa',name_en:'Visa',value:4},
          // {select:false,name_zh:'Mastercard',name_en:'Mastercard',value:3,long:true},
          // {select:false,name_zh:'Amex',name_en:'Amex',value:10},
          // {select:false,name_zh:'Stripe',name_en:'Stripe',value:11},
          // {select:false,name_zh:'信用卡',name_en:'Credit Card',value:12},
          // {select:false,name_zh:'支票',name_en:'Cheque',value:13},
        ]},
        {label:'order.orderType',select:false,child:[
          {select:false,name_zh:'堂食',name_en:'Dine-in',value:1},
          {select:false,name_zh:'外賣',name_en:'Take-away',value:2},
          {select:false,name_zh:'外賣平台',name_en:'Delivery Platforms',value:3},
          // {select:false,name_zh:'堂食',name_en:'Dine-in',value:4,long:true},
        ]},
        {label:'order.payStatus',select:false,child:[
          {select:false,name_zh:'未付款',name_en:'Unpaid',value:1},
          {select:false,name_zh:'已付款',name_en:'Paid',value:2},
          {select:false,name_zh:'部分支付',name_en:'Partially Paid',value:3},
          {select:false,name_zh:'已退款',name_en:'Refunded',value:4},
          // {select:false,name_zh:'無小費',name_en:'Untipped',value:10,special:true},
        ]},
      ],
      quickFilterBtns: [],
      quickFilterBtnSelected: '',
      
      tableOptions: [
        // { key: 'orderNo', width: '60' }, // 单号
        { key: 'shortdate', width: '60' }, // 日期
        { key: 'codeText', width: '86' }, // 台号/电话/姓名
        // { key: 'orderTypeText', width: '100' }, // 订单分类
        // { key: 'userCost', width: '60' }, // 消费金额
        // { key: 'payway', width: '100' }, // 支付方式
      ],
      tableDatas: [],
      tableIndex: '',
      tableRow: {},

      rowSelected: [],
      Dialog_merge_model: '',

      timer_order: null,

      otherHeight: 340,

      stockErrorFoods: [], // 余量不足

      expiredNoReturnCashOrderNum: 0, // 失效且未退款的订单数量，红点用
    }
  },
  methods: {
    // #region 表格中操作
    // 表格中外卖单特殊样式
    tableRowClassName({row, rowIndex}) {
      // console.log(`%crow:`, 'color: #00f;', row)
      if (row.orderType === 2) {
        return 'yellow-row'
      }
      return ''
    },
    // 表格勾选
    rowSelectedHandler(selection) {
      // console.log(`%cselection:`, 'color: #00f;', selection)
      this.rowSelected = selection
    },
    // 表格点击一行自动勾选
    rowClickedHandler(row, column, event) {
      // console.log(`%crow, column, event:`, 'color: #00f;', row, column, event)
      this.$refs.multipleTable.toggleRowSelection(row)
      // this.rowSelected.push(row)
    },
    // #endregion

    // #region 表格上方操作
    // 切換菜單
    selectNav(item, index) {
      this.navIndex = index
      this.resetPageData()

      this.searchClick()
    },
    // 重置data
    resetPageData() {
      this.pageData.currentPage = 1
      this.filters.forEach(x1 => {
        x1.select = false
        x1.child.forEach(x2 => {
          x2.select = false
        })
      })
      this.tableDatas = []
      this.tableIndex = ''
      this.tableRow = {}
      this.rowSelected = []
      this.Dialog_merge_model = ''
      this.quickFilterBtnSelected = ''
    },

    searchClearClick() {
      this.searchKey = ''
      this.searchClick()
    },

    // 快速筛选
    quickFilterClick(item) {
      // console.log(item)

      // #region 清空
      this.filters.forEach(x1 => {
        x1.select = false
        x1.child.forEach(x2 => {
          x2.select = false
        })
      })
      // #endregion

      const { id, orderStatusList, orderTypeList, payTypeList } = item

      // #region 重复点击
      if (this.quickFilterBtnSelected === id) {
        this.quickFilterBtnSelected = ''
        this.searchClick()
        return
      } else {
        this.quickFilterBtnSelected = id
      }
      // #endregion

      // #region 订单分类
      if (orderTypeList.includes(1)) {
        this.filters[1].child[0].select = true
      }
      if (orderTypeList.includes(2)) {
        this.filters[1].child[1].select = true
      }
      if (orderTypeList.includes(3)) {
        this.filters[1].child[2].select = true
      }
      if (orderTypeList.includes(1) && orderTypeList.includes(2) && orderTypeList.includes(3)) {
        this.filters[1].select = true
      } else {
        this.filters[1].select = false
      }
      // #endregion

      // #region 订单状态
      if (orderStatusList.includes(1)) {
        this.filters[2].child[0].select = true
      }
      if (orderStatusList.includes(2)) {
        this.filters[2].child[1].select = true
      }
      if (orderStatusList.includes(3)) {
        this.filters[2].child[2].select = true
      }
      if (orderStatusList.includes(4)) {
        this.filters[2].child[3].select = true
      }
      if (orderStatusList.includes(10)) {
        this.filters[2].child[4].select = true
      }
      if (this.sysEnv_x === 'us' && orderTypeList.includes(1) && orderTypeList.includes(2) && orderTypeList.includes(3) && orderTypeList.includes(4) && orderTypeList.includes(10)) {
        this.filters[2].select = true
      } else if (this.sysEnv_x === 'hk' && orderTypeList.includes(1) && orderTypeList.includes(2) && orderTypeList.includes(3) && orderTypeList.includes(4)){
        this.filters[2].select = true
      } else {
        this.filters[2].select = false
      }
      // #endregion

      // #region 付款方式
      payTypeList.forEach(x1 => {
        const ITEM = this.filters[0].child.find(x2 => x2.value === x1)
        ITEM && (ITEM.select = true)
      })
      const selectedArr = this.filters[0].child.filter(x1 => x1.select)
      if (selectedArr.length === this.filters[0].child.length) {
        this.filters[0].select = true
      } else {
        this.filters[0].select = false
      }
      // #endregion

      this.searchClick()
    },
    // #endregion

    // #region 抽屉栏中操作
    // 篩選 全選
    selectAll(item) {
      item.select = !item.select
      item.child.forEach(x => {
        !x.special && (x.select = item.select)
      })

      this.searchClick()
    },
    // 篩選 勾選
    selectItem(item, parsent) {
      item.select = !item.select
      if (!item.special) {
        let result = true
        parsent.child.forEach(x => {
          !x.select && (result = false)
        })
        parsent.select = result
      }

      this.searchClick()
    },
    // #endregion


    // 点击搜索
    searchClick(autoOnlyBendRead = false) {
      this.pageData.currentPage = 1
      this.search(autoOnlyBendRead)
    },
    // 搜索
    async search(autoOnlyBendRead = false) {
      let rD = {
        shopId: this.currentShopId,
        sortField: ['createTime'],
        sortType: 'DESC',
        pageSize: this.pageData.pageSize,
        pageNumber: this.pageData.currentPage,
        businessEndShow: true,
        filterCheckoutOrderItem: true,
        autoOnlyBendRead,
      }
      // 關鍵詞
      if (Number(this.searchKey)) {
        rD.orderNo = Number(this.searchKey)
        rD.contact = Number(this.searchKey)
      }
      let payTypeList = [], orderTypeList = [], statusArray = []
      // 付款方式
      this.filters[0].child.forEach(x => {
        x.select && payTypeList.push(x.value)
      })
      payTypeList.length && payTypeList.length < this.filters[0].child.length && (rD.payTypeList = payTypeList)
      // 订单分類
      this.filters[1].child.forEach(x => {
        x.select && orderTypeList.push(x.value)
      })
      orderTypeList.length && orderTypeList.length < this.filters[1].child.length && (rD.orderTypeList = orderTypeList)
      orderTypeList.includes(1) && orderTypeList.push(4)
      // 支付状态
      // const SELECT_1 = this.filters[2].child[0].select
      // const SELECT_2 = this.filters[2].child[1].select
      // if (SELECT_1 && SELECT_2) {
      // } else if (SELECT_1) {
      //   rD.statusArray = [1,2,3,4,5,6,7,8,9,10,99]
      // } else if (SELECT_2) {
      //   rD.statusArray = [100]
      // }
      // if (this.sysEnv_x === 'us') {
      //   const SELECT_3 = this.filters[2].child[2] ? this.filters[2].child[2].select : false
      //   SELECT_3 && (rD.startTipsFee = 0)
      // }
      this.filters[2].child.forEach(x => {
        x.select && statusArray.push(x.value)
      })
      // statusArray.length && statusArray.length < this.filters[2].child.length && (rD.statusArray = statusArray)
      rD.statusArray = statusArray

      rD.expiredOrder = this.navIndex === 1

      // const _R = await this.getData('order', rD, { replace: true })
      // console.log(`%c查询的订单:`, 'color: #f00;', _R)
      // this.dataHandle(_R)
      this.$api.order_search(rD).then(res => {
        if (res.status == 0) {
          this.pageData.total = res.size
          // console.log(`%c查询的订单:`, 'color: #f00;', res)
          this.dataHandle(res.data)
        } else { this._status(res) }
      })

      rD.expiredOrder = true
      rD.returnCash = false
      delete rD.pageNumber
      delete rD.pageSize

      this.$api.order_expired_search({ shopId: this.currentShopId }).then(res => {
        if (res.status == 0) {
          let _R2 = res.data
          // console.log(`%c查询的失效订单数量:`, 'color: #f00;', _R2)
          this.expiredNoReturnCashOrderNum = _R2
        } else { this._status(res) }
      })
      
      this.timer_order && clearInterval(this.timer_order)
      if (this.searchKey === '' && !payTypeList.length && !orderTypeList.length && !SELECT_1 && !SELECT_2) {
        this.timer_order = setInterval(() => {
          // console.log(`%c定时器执行了:`, 'color: #00f;', )
          this.search(true)
        }, 30000)
      }
    },
    
    // #region 小费
    tipClickHandler(row) {
      if (row.stripeTerminal) {
        this.$refs.DialogTip.open(row.id, row.serviceFee, row.tipsFee)
      } else {
        this.$refs.multipleTable.toggleRowSelection(row)
      }
    },
    // #endregion

    // 編輯订单
    editOrderClick(row) {
      if (row.orderType === 3) {
        // 所有的外卖平台订单都跳转到详情
        this.$router.push(`orderDetail?oid=${row.id}`)
        return
      }
      switch (row.status) {
        case 4: case 7: case 9:
          this.$router.push(`/calcwayFood?oid=${row.id}`)
          break
        case 5: case 8:
          this.$router.push(`/calcwayAvg?oid=${row.id}`)
          break
        case 6: case 10:
          this.$router.push(`/calcwayCus?oid=${row.id}`)
          break
        case 100:
          switch (row.userSelectPayType) {
            case 2:
              this.$router.push(`/calcwayAvg?oid=${row.id}`)
              break;
            case 3:
              this.$router.push(`/calcwayCus?oid=${row.id}`)
              break;
            case 4:
              this.$router.push(`/calcwayFood?oid=${row.id}`)
              break;
            default:
              this.$router.push(`orderDetail?oid=${row.id}`)
              break;
          }
          break
        default:
          this.$router.push(`/calcway?oid=${row.id}`)
          break
      }
    },
    // 取消订单
    cancelOrderClick(row) {
      this.tableRow = row
      if (row.status < 8) {
        if (row.sendPrinterList.length) {
          // 輸入密匙 打开对话框
          this.scan_canLeave_x_save(false)
          this.$refs.DialogKey.open({
            orderId: this.tableRow.id,
            sceneType: 3,
            onConfirm: this.sendAjax_CancelOrder
          })
        } else {
          this.sendAjax_CancelOrder()
        }
      }
    },
    // 刪除订单
    async sendAjax_CancelOrder() {
      const _D = await this.delData('order', { shopId: this.currentShopId, id: this.tableRow.id })
      if (_D === 'ok') {
        this.search()
      }
    },

    // #region 失效订单
    // 退款
    refundOrderClick(row) {
      this.tableRow = row
      this.$refs.DialogKey.open({
        orderId: this.tableRow.id,
        sceneType: 1,
        onConfirm: this.sendAjax_refund
      })
    },
    async sendAjax_refund() {
      const ORDER = this.tableRow
      console.log('订单eftpay', ORDER.eftPay)

      if (ORDER.eftPay) {
        const { id: orderId, payType, userCost } = ORDER
        await this.sendAjax_eftRefund({ orderId, payType, userCost }).then(() => {
          this.sendAjax_refund_send(ORDER)
        })
      } else {
        // 如果现金支付过，弹出钱箱
        if (ORDER.payTypeList && ORDER.payTypeList.includes(5)) {
          this.$tool.dsbridge_call(this.$tool.dsbridge_map.openCashDrawer, '')
        }
        this.sendAjax_refund_send(ORDER)
      }
    },
    sendAjax_refund_send(ORDER) {
      let rD = {
        shopId: this.currentShopId,
        id: ORDER.id,
      }
      this.$api.order_refund2(rD).then(res => {
        if (res.status == 0) {
          this.searchClick()
        } else { this._status(res) }
      })
    },
    // #endregion

    // #region eft退款
    sendAjax_eftRefund({ orderId, payType, userCost }) {
      return new Promise(async (resolve, reject) => {
        
        let rD = {
          shopId: this.currentShopId,
          orderId,
          payType,
          userCost,
          ip: this.readerId_x,
        }
        console.log(`%cEFT 请求参数:`, 'color: #00f;', rD)

        const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.eftRefund, rD)
        console.log(`%cEFT result:`, 'color: #00f;', RESULT)
        if (RESULT === 'error') {
          this.$message.error(this.$t('pay.eftRefundFailed'))
          reject()
        } else {
          resolve()
        }
        
      })
    },
    // #endregion
    
    // 打印賬單
    printOrderClick() {
      if (this.rowSelected.length === 1) {
        // 如果只有一個订单直接打印
        if (this.printerId_x) {
          this.$api.print_order({
            shopId: this.currentShopId,
            id: this.rowSelected[0].id
          }, this.printerId_x).then(res => {
            if (res.status == 0) {
            } else { this._status(res) }
          })
        } else { this.$message.warning(this.$t('print.printerError')) }
      } else if (this.rowSelected.length > 1) {
        //   如果有多個订单，彈出合併框
        this.scan_canLeave_x_save(false)
        this.$refs.Dialog_print.open()
      } else { this.$message.warning(this.$t('order.mustSelect')) }
    },
    // 循環打印小票模式
    batchPrint() {
      // 打印機正常
      if (this.printerId_x) {
        if (this.rowSelected.length) {
          this.rowSelected.forEach(x => {
            this.$api.print_order({
              shopId: this.currentShopId,
              id: x.id
            }, this.printerId_x).then(res => {
              if (res.status == 0) {
                this.scan_canLeave_x_save(true)
                this.$refs.Dialog_print.close()
              } else { this._status(res) }
            })
          })
        }
      } else { this.$message.warning(this.$t('print.printerError')) }
    },
    // 多個订单合併打印小票模式
    mergePrint() {
      this.scan_canLeave_x_save(true)
      this.$refs.Dialog_print.close()
      let noPayNum = 0, noFinNum = 0
      this.rowSelected.forEach(x => {
        x.status < 8 && noPayNum++
        x.status === 100 && noFinNum++
      })

      if (noPayNum !== this.rowSelected.length) {
        this.$message.warning(this.$t('print.partOrderIsPaid'))
      } else {
        // 打印機正常
        if (this.printerId_x) {
          this.$refs.Dialog_merge.open()
          this.Dialog_merge_model = 'print'
        } else { this.$message.warning(this.$t('print.printerError')) }
      }
    },
    calcClick() {
      if (this.rowSelected.length === 1) {
        let rD = {
          shopId: this.currentShopId,
          id: this.rowSelected[0].id,
        }
        this.$api.order_calc_before(rD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            if (_R.length) {
              // console.log(`%c_R:`, 'color: #f00;', _R)
              this.stockErrorFoods = _R.map(x => {
                if (x.saleOut) {
                  return {
                    text_zh: x.item.name_zh + ' 已售罄',
                    text_en: x.item.name_en + ' is sold out',
                  }
                } else {
                  return {
                    text_zh: x.item.name_zh + ' 可點數量' + x.availableCount + '份',
                    text_en: x.item.name_en + ' remains ' + x.availableCount + (x.availableCount === 1 ? ' order' : ' orders'),
                  }
                }
              })
              this.stockErrorFoods.push({
                text_zh: '請修改數量！',
                text_en: 'please change the quantity !',
              })
              this.$refs.DialogError.open()
            } else {
              this.calcOrder()
            }
          } else { this._status(res) }
        })
      } else if (this.rowSelected.length > 1) {
        let rD = {
          shopId: this.currentShopId,
          ids: this.rowSelected.map(x => x.id),
        }
        this.$api.order_calc_before(rD).then(res => {
          if (res.status == 0) {
            let _R = res.data
            if (_R.length) {
              // console.log(`%c_R:`, 'color: #f00;', _R)
              this.stockErrorFoods = _R.map(x => {
                if (x.saleOut) {
                  return {
                    text_zh: x.item.name_zh + ' 已售罄',
                    text_en: x.item.name_en + ' is sold out',
                  }
                } else {
                  return {
                    text_zh: x.item.name_zh + ' 可點數量' + x.availableCount + '份',
                    text_en: x.item.name_en + ' remains ' + x.availableCount + (x.availableCount === 1 ? ' order' : ' orders'),
                  }
                }
              })
              this.stockErrorFoods.push({
                text_zh: '請修改數量！',
                text_en: 'please change the quantity !',
              })
              this.$refs.DialogError.open()
            } else {
              this.calcOrder()
            }
          } else { this._status(res) }
        })
      } else { this.$message.warning(this.$t('order.mustSelect')) }
    },
    // 付款，勾選多個订单時，合併勾選订单
    calcOrder() {
      if (this.rowSelected.length === 1) {
        // 当只勾选了一个
        let { id, isNeedSend, cartItems, hasSendCookIds, status } = this.rowSelected[0]
        if (status === 100) {
          this.$message.warning(this.$t('print.orderIsPaid'))
        } else {
          if (isNeedSend) {
            this.autoPrint_here(id, cartItems, hasSendCookIds, () => { this.navToClac(this.rowSelected[0]) })
          } else {
            this.navToClac(this.rowSelected[0])
          }
        }
      } else if (this.rowSelected.length > 1) {
        // 当只勾选了多个
        let noPayNum = 0
        this.rowSelected.forEach(x => {
          x.status < 8 && noPayNum++
        })
        if (noPayNum !== this.rowSelected.length) {
          // 当只勾选的订单里有已进入付款阶段
          this.$message.warning(this.$t('print.partOrderIsPaid'))
        } else {
          this.$refs.Dialog_merge.open()
          this.Dialog_merge_model = 'calc'
        }
      } else { this.$message.warning(this.$t('order.mustSelect')) }
    },
    navToClac(order) {
      switch (order.status) {
        case 4:
        case 7:
        case 9:
          this.$router.push(`/calcwayFood?oid=${order.id}`)
          break
        default:
          this.$router.push(`/calcway?oid=${order.id}`)
          break
      }
    },
    
    autoPrint_here(orderId, itemsAll, itemIdsSent, callback) {
      this.$confirm(this.$t('print.foodNotSent'), this.$t('common.tips'), {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning',
        distinguishCancelAndClose: true,
      }).then(async () => {
        // Mark 现在发送过有未发送不再发送
        callback && callback()
      })
    },
    // 取消合并
    closeDialogMerge() {
      this.scan_canLeave_x_save(true)
      this.$refs.Dialog_merge.close()
    },
    // 確認合併
    async continueMerge() {
      this.el_loading_x_save(true)
      const ORDER_IDS_CHECKED = this.rowSelected.map(x => x.id)
      let rD = {
        shopId: this.currentShopId,
        orderIdList: ORDER_IDS_CHECKED
      }
      await this.$api.order_merge(rD).then(res => {
        if (res.status == 0) {
          let _R = res.data
          console.log(`%c合并后的订单:`, 'color: #f00;', _R)

          this.search()

          this.$refs.Dialog_merge.close()
          
          _R.cartItems = _R.orderItemDetailList
          _R.hasSendCookIds = _R.sendPrinterList.map(x => x.orderItemId)
          const NUM_NEED = _R.cartItems.length
          const NUM_SENT = _R.hasSendCookIds.length
          _R.isNeedSend = NUM_SENT > 0 && NUM_NEED !== NUM_SENT // 发送的菜品

          // 判断弹框弹出的点击按钮
          if (this.Dialog_merge_model === 'print') {
            // 如果是合并打印
            this.$api.print_order({
              shopId: this.currentShopId,
              id: _R.id
            }, this.printerId_x).then(res => {
              if (res.status == 0) {
              } else { this._status(res) }
            })
          } else if (this.Dialog_merge_model === 'calc') {
            // 如果是合并结账
            let { id, isNeedSend, cartItems, hasSendCookIds } = _R
            if (status === 100) {
              this.$message.warning(this.$t('print.orderIsPaid'))
            } else {
              if (isNeedSend) {
                this.autoPrint_here(id, cartItems, hasSendCookIds, () => { this.navToClac(_R) })
              } else {
                this.navToClac(_R)
              }
            }
          }
        } else { this._status(res) }
      })
      this.el_loading_x_save(false)
    },
    dataHandle(_R) {
      const ARR_NEW = _R.map((x, i) => {
        let newItem = {}
        newItem.id = x.id
        newItem.costOrigin = Math.round((x.userCost - x.tipsFee - x.serviceFee) * 100) / 100
        newItem.userCost = x.userCost
        newItem.tipsFee = x.tipsFee
        newItem.serviceFee = x.serviceFee
        newItem.status = x.status
        newItem.orderNo = x.orderNo
        newItem.returnCash = x.returnCash // 是否退款
        newItem.combineOrder = x.combineOrder // 是否合并
        newItem.eftPay = x.eftPay
        newItem.payType = x.payType
        newItem.payTypeList = x.payTypeList
        newItem.payTypeNameList = x.payTypeNameList
        newItem.orderType = x.orderType
        newItem.userSelectPayType = x.userSelectPayType
        newItem.stripeTerminal = x.stripeTerminal
        newItem.shortdate = x.createDate.substr(5,11).replace('-','/')
        if (x.code) {
          newItem.codeText = x.code + (x.showNo > 1 ? ('-' + x.showNo ) : '')
        } else if (x.contact) {
          newItem.codeText = x.contact
          if (x.userName) {
            newItem.codeText += '/' +  x.userName
          }
        } else if (x.userName) {
          newItem.codeText = x.userName
        } else {
          newItem.codeText = ''
        }

        newItem.cartItems = x.orderItemDetailList
        newItem.sendPrinterList = x.sendPrinterList
        newItem.hasSendCookIds = x.sendPrinterList.map(x => x.orderItemId)
        const NUM_NEED = newItem.cartItems.length
        const NUM_SENT = newItem.hasSendCookIds.length
        newItem.isNeedSend = NUM_SENT > 0 && NUM_NEED !== NUM_SENT // 发送的菜品
        
        return newItem
      })

      if (JSON.stringify(this.tableDatas) !== JSON.stringify(ARR_NEW)) {
        this.tableDatas = []
        this.$nextTick(() => {
          this.tableDatas = ARR_NEW
        })
        console.log(`%c处理后订单:`, 'color: #00f;', this.tableDatas)
      }
    },
    getTableData() {
      this.search()
    },
    // 获取数据
    init() {
      this.search()
    },
    async initPayType() {
      // #region 支付方式
      const _R = await this.getData('paytype', {
        shopId: this.currentShopId,
        queryTransientData: true
        // enable: true
      })
      console.log(`%c支付方式:`, 'color: #f00;', _R)
      this.filters[0].child = _R.map(x1 => ({
        select: false,
        name_zh: x1.name_zh,
        name_en: x1.name_en,
        value: x1.type,
      }))

      if (this.sysEnv_x === 'us') {
        this.filters[2].child.push({
          select: false,
          name_zh: '無小費',
          name_en: 'Untipped',
          value: 10,
          special: true,
        })
      }
      // #endregion

      // #region 筛选条件
      const _R2 = await this.getData('filter', {
        shopId: this.currentShopId,
      })
      console.log(`%c筛选条件:`, 'color: #f00;', _R2)
      this.quickFilterBtns = _R2.map(x1 => {
        x1.select = false
        return x1
      })
      // #endregion
    },
  },
  // created() {
  //   this.initPayType()
  // },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initPayType()
      if (to.query.type === 'orderManage2' && vm.navIndex !== 1) {
        vm.selectNav({name:'orderManage2'}, 1)
      } else if (to.query.type !== 'orderManage2' && vm.navIndex !== 0 || to.query.refresh) {
        vm.$router.replace('/order')
        vm.selectNav({name:'orderManage'}, 0)
      } else {
        vm.searchClick(true)
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    this.timer_order && clearInterval(this.timer_order)
    this.$refs.multipleTable.clearSelection()
    this.isDrawerAc = false
    next()
  },
}
</script>

<style lang='scss' scoped>
@import '@/assets/css/util_table.scss';
// .wrapper-order{padding-left: 20px;box-sizing: border-box;}
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;
  overflow: scroll hidden;z-index: 3;position: relative;
  .nav{padding: 0 10px;width: auto;white-space: nowrap;}
  .nav.active{font-weight: bold;}
  .dot /deep/.el-badge__content{background: #EA4646;border: 0;bottom: 0;margin: auto;right: 10px;}
  .draw-switch{position: absolute;top: 0;bottom: 0;right: 40px;margin: auto;width:40px;height:40px;}
}

.section-search{
  height: 80px;background: #fff;z-index: 3;position: relative;padding: 0 20px;box-sizing: border-box;
  .box{position: relative;}
  .input{width: 300px;height: 36px;border: none;background: #EEEEEF;border-radius: 8px;padding: 0 36px;box-sizing: border-box;}
  .input2{width: 200px;padding: 0 16px;}
  .icon{position: absolute;left: 8px;top: 0;bottom: 0;margin: auto;width: 20px;height: 20px;}
  .text{color: #1890FF;padding: 20px 30px 20px 30px;}

  .box2 .text{margin-right: 80px;}

  .box3{
    padding: 0 10px;height: 100%;align-content: space-around;
    // border-left: 1px solid #1890FF;
    .btn{margin: 0 10px;}
  }
}

.mydialog{
  padding: 0 20px;
  .input{width: 366px;height: 50px;line-height: 50px;margin-top: 110px;}
}

.section-table{
  height: calc(100% - 180px);margin-top: 20px;
  .table-box{height: calc(100% - 100px);overflow: hidden scroll;} // height: calc(100% - 140px);
  // /deep/.el-table__header-wrapper{position: relative;top: 0;}

  .edit-btn{width: 80px;height: 30px;}
  .delete-btn{width: 50px;height: 30px;box-sizing: border-box;border: 1px solid #374978;position: relative;background: #fff;}
  .delete-btn.delete-btn-disable::after{
    content: '';display: inline-block;width: 100%;height: 100%;
    background: rgba($color: #fff, $alpha: 0.7);color: #fff;font-size: 20px;
    position: absolute;top: 0;left: 0;display: flex;justify-content: center;align-items: center;
  }

  .section-total{height: 50px;line-height: 50px;padding: 0 40px;}
  .section-btns{
    position: absolute;bottom: 20px;right: 20px;
    .btn{margin: 20px;}
  }

}
/deep/.el-table .yellow-row{background: #FCFDE0;}


// 抽屜
.section-drawer{
  position: relative;height: 0;
  .drawer{
    position: absolute;width: 100%;height: auto;transition: all .3s;
    top: -200px;background: transparent;z-index: -1;box-shadow: 0 0 20px 0 #ccc;
    &.active{top: 0;background: #fff;z-index: 2;}
  }
  .drawer{
    padding: 0 20px;box-sizing: border-box;
    .items{
      flex: 1;
      .item{
        position: relative;padding-bottom: 20px;
        &:nth-child(1){flex: 32;}
        &:nth-child(2){flex: 32;}
        &:nth-child(3){flex: 15;}
        &:nth-child(n+2){
          padding-left: 20px;
          &::after {
            content: '';display: inline-block;width: 1px;height: 80%;
            background: #1890FF;position: absolute;top: 10%;left: 0;
          }
        }
        .item-label{height: 62px;line-height: 62px;}
        .item-options{
          .option{margin: 0 24px 16px 0;} // width: 90px;
          // .option-l{width: 120px;}
          .value{letter-spacing: 0;}
        }
      }
    }
    .btn{width: 80px;height: 30px;line-height: 30px;margin-right: 35px;}
  }
}


// 合併
.mydialog-merge{
  padding: 0 45px;height: 290px;
  .text{min-height: 40px;line-height: 40px;word-break: keep-all;text-align: center;}
}


// 頁碼
/deep/.el-pagination{text-align: left;margin-left: 40px;}
</style>